import React from 'react';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { SelectableCheckbox } from './selectable';
import { UserRow } from './user';

interface SelectableUserRowProps {
  user: API.ShortUserFragment;
  selected: boolean;
  radio: boolean;
  onPress: (user: API.ShortUserFragment) => void;
}

export class SelectableUserRow extends React.PureComponent<SelectableUserRowProps> {
  onPress = () => this.props.onPress(this.props.user);
  render() {
    return (
      <UserRow
        user={this.props.user}
        onPress={this.onPress}
        subtitle={!!this.props.user.username && `@${this.props.user.username}`}
        icon={
          <View fill center>
            <SelectableCheckbox selected={this.props.selected} />
          </View>
        }
      />
    );
  }
}
